import { combineReducers } from 'redux';
import mergeWith from 'lodash/merge';
import session from './session';
import listings from './listings';
import reports from './reports';
import emails from './emails';
import masters from './masters';
import zendesk from './zendesk';
import { AUTH_LOGOUT } from 'actions/session';

const defaultState = {
  listings: {}
};

const entities = (state = defaultState, action) => {
  if (action.response && action.response.entities) {
    return mergeWith({}, state, action.response.entities, (src, dest) => {
      // Deep merge arrays
      if (Array.isArray(src)) {
        return dest;
      }
    });
  }

  return state;
};

const appReducer = combineReducers({
  entities,
  session,
  listings,
  reports,
  emails,
  masters,
  zendesk,
});

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;
